import { z } from 'zod';

export const PinCodeDtoScheme = z.object({
	current_pin_code: z.string().nullable().describe('Текущий пин-код'),
	current_pin_code_expiry_date: z.string().nullable().describe('Дата действия текущего пин-кода'),
	next_pin_code: z.string().nullable().describe('Новый пин-код'),
});

export type PinCodeDto = z.infer<typeof PinCodeDtoScheme>;
